import useFetch from "@hooks/useFetch";
import {components, paths} from "@api/api";
import {useCallback, useState} from "react";

const path: keyof paths = '/api/Benchmark/CustomBenchmarkSet';
export type CustomBenchmarkSetData = components["schemas"]["CustomBenchmarkSet"];

export function useCustomBenchmarkSet() {
    const request = useFetch<CustomBenchmarkSetData>({
        url: path,
    });

    const updateRequest = useFetch<CustomBenchmarkSetData>({
        url: path,
        method: "POST",
        lazy: true,
    });

    const deleteRequest = useFetch<void>({
        url: path,
        method: "DELETE",
        lazy: true,
    });

    const updateData = useCallback(
        async (data: CustomBenchmarkSetData) => {
            await updateRequest.doFetch({
                data,
            });
            await request.doFetch();
            return;
        },
        [updateRequest, request],
    );

    const deleteData = useCallback(
        async () => {
            await deleteRequest.doFetch();
            await request.doFetch();
        },
        [deleteRequest, request],
    );

    const isLoading = request.isLoading || updateRequest.isLoading || deleteRequest.isLoading;

    return {
        isLoading,
        data: request.data,
        updateData,
        deleteData,
    };
}